import { Tooltip } from '@mui/material';
import EAIcon from 'components/common/EAIcon';
import i18next from 'i18next';
import { getEvDataScopeChangeFieldValue, getScorePerformanceByValue } from 'services/common/EcovadisUtils';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';
import clsx from 'clsx';

export const EcovadisScorePerformanceLabel = ({evData, score, className}) => {
  const { classes } = useStyles();
  const scorePerformance = getScorePerformanceByValue(getEvDataScopeChangeFieldValue(evData, score));
  return (
      <div
        className={clsx(
          classes.globalScorePerformance,
          scorePerformance,
          className || ""
        )}
      >
        {i18next.t(`ecovadis.performance.${scorePerformance}`)}
      </div>
  )
}

const EcovadisGlobalScore = ({ evData }) => {
  const { classes } = useStyles();

  const getChartIcon = (value) => {
    return `gauge_${getScorePerformanceByValue(value)}`;
  };

  return (
    <div className={classes.globalScoreWrapper}>
      <div className={classes.globalScoreTitle}>
        {i18next.t(`ecovadis.scores.global_score`)}
        <Tooltip
          title={i18next.t(`ecovadis.scoresTooltips.global_score`)}
          placement="top"
          arrow
        >
          <span>
            <EAIcon icon="info-rounded" />
          </span>
        </Tooltip>
      </div>
      <div className={classes.globalScoreChart}>
        <EAIcon icon={`ecovadis/${getChartIcon(getEvDataScopeChangeFieldValue(evData, 'global_score'))}`} />
        <div className={classes.globalScore}>
          <span className="score">{getEvDataScopeChangeFieldValue(evData, 'global_score')}</span>
          <span className="max-score">/100</span>
        </div>
      </div>
      <div className={classes.globalScoreDivider}></div>
      <div className={classes.globalScoreLabel}>
        {/* <EAIcon /> */}
        <EcovadisScorePerformanceLabel evData={evData} score={"global_score"}/>
      </div>
    </div>
  );
};

export default EcovadisGlobalScore;
